import { formatUnits } from 'ethers';

import { cn } from 'app/utils/styles.utils';
import { useAsset } from 'app/hooks/useAsset';

export const Card = ({children}: {children: React.ReactNode}) => {
  return (
    <div className="border-transparent card flex w-fit flex-col">
      {children}
    </div>
  );
};

export const CardContent = ({
  title,
  value,
  variant,
  isEden,
}: {
  title: string;
  value: number;
  variant?: 'default' | 'blue' | 'green';
  isEden?: boolean;
}) => {
  const asset = useAsset('ELYS');
  return (
    <div className="flex flex-col gap-1.5">
      <p className="text-[12px] text-neutral-300">{title}</p>
      <p
        className={cn(
          'text-xl font-semibold',
          variant === 'blue' && 'text-light-blue-500',
          variant === 'green' && 'text-success',
        )}>
        {`${formatUnits(value.toString(), asset.coinDecimals)} ${
          isEden ? 'EDEN' : 'ELYS'
        }`}
      </p>
    </div>
  );
};

